import { Caption, CaptionProps, Heading, HeadingProps } from '@farol-ds/react'
import classNames from 'classnames'
import { Children, cloneElement, HTMLAttributes, isValidElement } from 'react'

import styles from './appbar-start-content.module.scss'

export type AppBarStartContentElement = HTMLDivElement

export type AppBarStartContentProps = HTMLAttributes<AppBarStartContentElement>

function AppBarStartContent(props: AppBarStartContentProps) {
  const { children, className, ...rest } = props
  const classes = classNames(styles.root, className)
  return (
    <div {...rest} className={classes}>
      {renderChildren(children)}
    </div>
  )
}

function renderChildren(children: React.ReactNode) {
  return Children.map(children, (child) => {
    if (isValidElement(child)) {
      switch (child.type) {
        case Caption:
          return cloneElement(child, {
            className: classNames(styles.truncateLine, child.props.className),
          } as CaptionProps)

        case Heading:
          return cloneElement(child, {
            size: 'sm',
            className: classNames(styles.truncateLine, child.props.className),
          } as HeadingProps)
      }
    }
    return child
  })
}

export default AppBarStartContent
